import { COMMA, ENTER } from '@angular/cdk/keycodes'
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core'
import { FormControl } from '@angular/forms'
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA
} from '@angular/material'
import { Subject } from 'rxjs'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { AppService,InstructionService, DialogService, StateService } from '../../../../../services'
import { ConfirmComponent } from '../../../layout/dialogs/confirm-dialog/confirm.component'
import * as moment from 'moment'
const KEY = 'intruction-actions-dialog'



@Component({
	selector: 'atyl-intrction-actions-dialog',
	templateUrl: './instruction-actions-dialog.component.html',
	styleUrls: ['./instruction-actions-dialog.component.scss'],
})
@Stringable({
	path: 'views/partials/content/actions/instruction-actions-dialog',
	key: KEY
})
export class InstructionActionsDialog extends BaseDialogComponent implements OnInit {
	loading: boolean = false;
	
    instructionType: any;
    oinstruction: any;
    dossier: any;
    multiDossier: any = null;
    instruction:any;
    instructeurs:any[]=[];
    invalidDate = false;
    dateBeginInput: any;
    dateEndInput: any;
    demandeTypeInput: any;
    instructeurInput: any;
	comment:any;
	@StringableValues(KEY) strings: any
	
	now:any=new Date();
	
	title: any
	
    errors:any =[]
    errorMessage:string ="";
    link:any;
    user:any;
    
	private debounce: Subject<string> = new Subject();
	
	constructor(
		changeDetectorRef: ChangeDetectorRef,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<InstructionActionsDialog>,
		public dialog: MatDialog,
		private stateService: StateService,
	   private instructionService:	InstructionService,
		private appService: AppService,
		dialogService: DialogService

	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
        
        this.dateBeginInput=this.now;
        console.log("dossier:",this.data);
		if (this.data) {
			if(this.data.typeDossier!=undefined && this.data.typeDossier=="multi"){
                this.multiDossier = []
                this.data.dossier.forEach(tiers => {
                    this.multiDossier.push(tiers.dossier)
                });
            }
			if (this.data.instruction_type!=undefined && this.data.instruction_type)
			  this.instructionType=this.data.instruction_type;
			
			
			  
			 if (this.data.dossier!=undefined && this.data.dossier && !this.multiDossier)
              this.dossier=this.data.dossier;
              if (this.data.link!=undefined && this.data.link)
			 	 this.link=this.data.link;
			 	 
            if (this.instructionType)   
			     this.instructionService.type(this.instructionType).subscribe((res: JSONRpcResponse) => {
                    this.oinstruction = res.result;
                    if (this.oinstruction.demande_type.length==1)
                        this.demandeTypeInput=this.oinstruction.demande_type[0];
                    
                    this._changeEnd();
                    this.stateService.user.subscribe((user) => {
                        this.user = user;
                        this.changeDetectorRef.detectChanges();
                        this._loadInsructeur();
                    })
                    
                    this.changeDetectorRef.detectChanges();
                }
                
                
            );
		}
		/*
		let professions = [];
		
		this.debounce.pipe(
		       debounceTime(1000)
		     ).subscribe(search => {
		       if (search.length > 0) {
		         this.appService.getUsersByProfressions(professions, this.dossier.ID, search).subscribe((result) => {
		           this.instructeurs = result.result
		           this.changeDetectorRef.detectChanges()
		         })
		       }

		 })
		*/
		
	}
	
	 changeDate(event: any,begin:boolean) {
        if (event.value) {
            if (moment.isDate(event.value)) {
                this.invalidDate = false
            } else {
                this.invalidDate = true
            }
        } else {
            this.invalidDate = true
        }
        
        if (!this.invalidDate
          && begin
        ) {
            this._changeEnd();
            this.changeDetectorRef.detectChanges();
        }
        
    }
    
    _loadInsructeur() {
        let professions:any[]=[];
        this.oinstruction.professions.forEach(element => {
            professions.push(element.key);
        });
		let defaultAuto:any[]=[
					{
						ID:"auto",
						PRENOM:"",
						NOM:"(Affectation automatique)"
						
					}
					
			];
		
       /* this.instructeurs=[
			{
				ID:"auto",
				PRENOM:"",
				NOM:"(Affectation automatique)"
				
			}
			
		];*/
		this.instructeurs=[];
        let IDdossier=null;
        if (this.dossier!=undefined && this.dossier)
                IDdossier=this.dossier.ID;
		this.debounce.pipe(
				       debounceTime(1000)
				     ).subscribe(search => {
				       if (search.length > 0) {
						this.instructeurs=[];
				        this.appService.getUsersByProfressions(professions, IDdossier, search).subscribe((result) => {
							this.instructeurs =defaultAuto.concat( result.result);
							 this.instructeurInput = this.instructeurs.find(instructeur => instructeur.ID === this.user.id);
							 this.changeDetectorRef.detectChanges();
				         })
				}

		})
		
        this.appService.getUsersByProfressions(professions,IDdossier).subscribe((result) => {
           this.instructeurs =defaultAuto.concat( result.result);
            this.instructeurInput = this.instructeurs.find(instructeur => instructeur.ID === this.user.id);
            this.changeDetectorRef.detectChanges();
        });
		
        
    }
    
    _changeEnd() {
        
        if (
           this.oinstruction
           && this.oinstruction.duree!=undefined
            && this.oinstruction.duree_type!=undefined
            && this.oinstruction.duree!=null 
            && this.dateBeginInput
            && this.dateBeginInput instanceof Date
             ) {
           this.dateEndInput=new Date( this.dateBeginInput.valueOf() );
           if (this.oinstruction.duree_type>0)
            this.dateEndInput.setMonth(this.dateEndInput.getMonth()+this.oinstruction.duree);
           else
              this.dateEndInput.setDate(this.dateEndInput.getDate()+this.oinstruction.duree);
              
            console.log("date end",this.dateBeginInput,this.dateEndInput,this.oinstruction.duree,this.oinstruction.duree_type);  
         }             
    }
    
    
    submitForm(event: any) {
        this.errors =[]
        this.errorMessage ="";
        
        let _options = {
            debut: this.dateBeginInput,
            fin: this.dateEndInput,
            demande_type: (this.demandeTypeInput!=undefined && this.demandeTypeInput) ?this.demandeTypeInput.ID: null,
            dossier: (this.dossier !=undefined && this.dossier ) ? this.dossier.ID: null,
            instructeur : (this.instructeurInput!=undefined && this.instructeurInput) ? this.instructeurInput.ID : 'auto',
			comment: this.comment,
            titre : (this.title!=undefined && this.title.length>0) ? this.title : null,
            visite: this.data.visite? this.data.visite:null,
            link: this.link
        }
        if(this.getErrors(_options) == 0){
            let instructionID=0;
            if (this.instruction!=undefined && this.instruction)
                instructionID=this.instruction.ID;
          console.log("set instruction",this.instructionType,instructionID,_options) ;
          this.instructionService.set(this.data.instruction_type, instructionID, _options)
            .subscribe((res: JSONRpcResponse) => {
                if (res.result) {
                    console.log('set result', res.result )
                    this.dialogRef.close(res.result.ID)
                    this.stateService.selectNewCreatedInstruction(res.result);
                }
            })
        }
    }

    submitMultiForms(event: any) {
        // Afficher la boîte de dialogue de confirmation
        const dialogRef = this.dialog.open(ConfirmComponent, {
            data : {
                libelle : "Etes-vous sûr de vouloir créer "+ this.multiDossier.length +" Procédures ?"
            },
        });
    
        dialogRef.afterClosed().subscribe((confirm) => {
          if (confirm) {
            this.executeSubmitMultiForms();
          }
        });
    }
    
    executeSubmitMultiForms(){
        let dossiersIDS = []
        if(this.multiDossier){
            this.multiDossier.forEach(dossier => {
                dossiersIDS.push(dossier.dossierID)
            });
        }
        let _options = {
            debut: this.dateBeginInput,
            fin: this.dateEndInput,
            demande_type: (this.demandeTypeInput!=undefined && this.demandeTypeInput) ?this.demandeTypeInput.ID: null,
            dossier: (dossiersIDS.length>0 ) ? dossiersIDS: null,
            instructeur : (this.instructeurInput!=undefined && this.instructeurInput) ? this.instructeurInput.ID : 'auto',
            titre : (this.title!=undefined && this.title.length>0) ? this.title : null
        }
        if(this.getErrors(_options) == 0){
            let instructionID=0;
            if (this.instruction!=undefined && this.instruction)
                instructionID=this.instruction.ID;
            console.log("set instruction",this.instructionType,instructionID,_options) ;
            this.instructionService.setMulti(this.data.instruction_type, instructionID, _options)
                .subscribe((res: JSONRpcResponse) => {
                if (res.result) {
                    console.log('set result', res.result )
                    this.dialogRef.close(true)
                    this.stateService.selectNewCreatedInstruction(res.result);
                    this.changeDetectorRef.detectChanges()
                }
            })
        }
    }

    getErrors(_options:any){
        if (
            _options.dossier==undefined
            || ! _options.dossier 
            )
            this.errors.push("Aucun tiers");
        
        if (
            _options.demande_type==undefined
            || ! _options.demande_type 
            )
            this.errors.push("Type de demande");
         if (
            _options.instructeur==undefined
            || ! _options.instructeur 
            )
            this.errors.push("Aucun instructeur");
                
        if (
           ! _options.debut
           || !( _options.debut instanceof Date)
           )
            this.errors.push("Une date de début");
        
           
        if (
             _options.fin 
             && !( _options.fin instanceof Date)
             )
            this.errors.push("Une date de fin");   
                     
         if (
             !this.instructionType
             )
            this.errors.push("Type de procédure");  

         if (this.errors.length>0) {
         
             this.errorMessage="<ul><li>"+this.errors.join("</li><li>")+"</li></ul>";
             this.changeDetectorRef.detectChanges();
         }
         return this.errors.length
    }
      
	triggerAutocompSelectionList(search: any) {
	   this.debounce.next(search)
	 }    
	 
	 displayAutoSelectListInstru(key?: any): string | undefined {
	     let selected
	     if ( this.instructeurs.length>0) {
	       this.instructeurs.forEach((select) => {
	         if (key && select.ID === key.ID)
	           selected = select
	       })
	     }
	     return selected ? selected.NOM + ' ' + (selected.PRENOM ? selected.PRENOM : '') : undefined
	 }
	
}
